import { ShieldCheck, Lock, CheckCircle } from "lucide-react";

const SOCIAL_LINKS = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/rlrefrigeracao2016",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/rl.refrigeracao.7",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@rlrefrigeracao7604",
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1 - Logo & Description */}
          <div className="lg:col-span-1">
            <img
              src="/assets/RL-Fregrigeracao/logo-semfundo.png"
              alt="RL Refrigeração"
              className="h-16 w-auto mb-4 brightness-0 invert"
              loading="lazy"
            />
            <p className="text-sm text-slate-400 leading-relaxed font-['Manrope']">
              Desde 2016 oferecendo soluções completas em refrigeração e climatização em Goiânia e região.
            </p>
            {/* Social Links */}
            <div className="flex gap-3 mt-5">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                  aria-label={social.name}
                  className="w-10 h-10 bg-white/10 rounded-sm flex items-center justify-center text-white hover:bg-[#0E86D4] transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 - Services */}
          <div>
            <h4 className="text-sm font-bold font-['Barlow_Condensed'] uppercase tracking-wider mb-4 text-white">
              Serviços
            </h4>
            <ul className="space-y-2.5">
              {[
                "Instalação de Ar Condicionado",
                "Manutenção de Ar Condicionado",
                "Câmaras Frias",
                "Refrigeração Hospitalar",
                "Sistema de Chiller",
                "Torre de Resfriamento",
              ].map((service) => (
                <li key={service}>
                  <a href="#servicos" className="text-sm text-slate-400 hover:text-[#0E86D4] transition-colors font-['Manrope']">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Contact */}
          <div>
            <h4 className="text-sm font-bold font-['Barlow_Condensed'] uppercase tracking-wider mb-4 text-white">
              Contato
            </h4>
            <ul className="space-y-2.5 text-sm text-slate-400 font-['Manrope']">
              <li>
                <a href="tel:+5562986293474" className="hover:text-[#0E86D4] transition-colors">
                  (62) 98629-3474
                </a>
              </li>
              <li>
                <a href="mailto:rlrefrigeracaogoiania@gmail.com" className="hover:text-[#0E86D4] transition-colors">
                  rlrefrigeracaogoiania@gmail.com
                </a>
              </li>
              <li>Goiânia - GO</li>
              <li>Seg - Sáb: 08:00 - 18:00</li>
            </ul>
          </div>

          {/* Col 4 - Trust Badges */}
          <div>
            <h4 className="text-sm font-bold font-['Barlow_Condensed'] uppercase tracking-wider mb-4 text-white">
              Segurança
            </h4>
            <div className="space-y-4">
              <div className="trust-badge flex items-center gap-3 bg-white/5 rounded-sm p-3">
                <Lock className="w-8 h-8 text-green-400 flex-shrink-0" />
                <div>
                  <p className="text-xs font-bold text-white font-['Barlow_Condensed'] uppercase">SSL Seguro</p>
                  <p className="text-xs text-slate-400 font-['Manrope']">Conexão criptografada</p>
                </div>
              </div>
              <div className="trust-badge flex items-center gap-3 bg-white/5 rounded-sm p-3">
                <ShieldCheck className="w-8 h-8 text-[#0E86D4] flex-shrink-0" />
                <div>
                  <p className="text-xs font-bold text-white font-['Barlow_Condensed'] uppercase">Site Verificado</p>
                  <p className="text-xs text-slate-400 font-['Manrope']">Navegação segura</p>
                </div>
              </div>
              <div className="trust-badge flex items-center gap-3 bg-white/5 rounded-sm p-3">
                <CheckCircle className="w-8 h-8 text-[#FBBC04] flex-shrink-0" />
                <div>
                  <p className="text-xs font-bold text-white font-['Barlow_Condensed'] uppercase">Google Verificado</p>
                  <p className="text-xs text-slate-400 font-['Manrope']">4.9 estrelas - 127 avaliações</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-slate-500 font-['Manrope']">
              © {new Date().getFullYear()} RL Refrigeração - Todos os direitos reservados. CNPJ: Empresa constituída desde 2016.
            </p>
            <p className="text-xs text-slate-500 font-['Manrope']">
              Goiânia - GO | Atendemos toda a região metropolitana
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
